import { render, staticRenderFns } from "./Gallery.htm?vue&type=template&id=2e8c309c&scoped=true&"
import script from "./Gallery.js?vue&type=script&lang=js&"
export * from "./Gallery.js?vue&type=script&lang=js&"
import style0 from "./Gallery.scss?vue&type=style&index=0&id=2e8c309c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c309c",
  null
  
)

export default component.exports